export { default as translatorFactory } from './translatorFactory';
